"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import GroupCardsRow from "../../homePageGroupSearch/GroupCardsRow"
import renderGroupCards from "../GroupCard/renderGroupCards"
import SuggestGroupSection from "../../../common/SuggestGroupSection"
import {
  SEARCH_TYPE_GROUPS,
  SEARCH_TYPE_ORGANIZATIONS,
  SEARCH_TYPE_PROVIDERS,
  type SearchType,
} from "../../../../lib/search/searchParams"

const EMPTY_COPY: Record<SearchType, { header: string; body: string }> = {
  [SEARCH_TYPE_GROUPS]: { header: "Your search results", body: "" },
  [SEARCH_TYPE_PROVIDERS]: {
    header: "Providers",
    body: "No providers match this search yet. Try a different name, specialty or location, or clear the location to see providers everywhere.",
  },
  [SEARCH_TYPE_ORGANIZATIONS]: {
    header: "Organizations",
    body: "No organizations match this search yet. Try a different name or specialty, or clear the location to see organizations everywhere.",
  },
}

function EmptySearchResults({
  searchTerm,
  suggestedGroups,
  type = SEARCH_TYPE_GROUPS,
}: {
  searchTerm?: string | null
  suggestedGroups?: ReadonlyArray<Record<string, unknown>>
  type?: SearchType
}) {
  const copy = EMPTY_COPY[type] ?? EMPTY_COPY[SEARCH_TYPE_GROUPS]

  const renderHeader = () => {
    return (
      <h1 className="text-[23px] tracking-[1px] min-[600px]:text-[28px] tracking-[1.96px] font-bebas m-[0px]">
        {searchTerm ? `${copy.header}: ${searchTerm}` : copy.header}
      </h1>
    )
  }

  const renderUpcomingGroups = () => {
    return suggestedGroups?.length > 0 ? (
      <GroupCardsRow
        header={"Upcoming Groups"}
        cards={renderGroupCards(suggestedGroups)}
      />
    ) : null
  }

  return (
    <div className="flex justify-center px-4">
      <div className="pt-[40px] max-w-[1125px] w-full">
        {renderHeader()}
        {type === SEARCH_TYPE_GROUPS ? (
          <>
            <SuggestGroupSection />
            {renderUpcomingGroups()}
          </>
        ) : (
          <p
            className="pt-[20px] text-[19px] leading-[140%] tracking-[.54px] text-[#7A7A7A]"
            data-testid="empty-search-copy"
          >
            {copy.body}
          </p>
        )}
      </div>
    </div>
  )
}

export default EmptySearchResults
